import React from "react";
import type {
  StyleProp,
  ViewStyle,
  ImageURISource,
  ImageStyle,
} from "react-native";
import {
  StyleSheet,
  View,
  ActivityIndicator,
  Image,
  Text,
} from "react-native";

interface Props {
  style?: StyleProp<ViewStyle>
  index?: number
  showIndex?: boolean,
  item?: string | Object,
  imageStyle?: StyleProp<ImageStyle>
}

export const SBImageItem: React.FC<Props> = ({
  style,
  index: _index,
  showIndex = true,
  item,
  imageStyle
}) => {
  const index = (_index || 0) + 1;
  const source = React.useRef<ImageURISource>(item && typeof item === 'string' ? { uri: item } : {
    uri: `https://picsum.photos/id/${index}/400/300`,
  }).current;

  return (
    <Image key={index} style={[styles.image, imageStyle]} source={source} />
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    borderRadius: 8,
  },
  image: {
    flex: 1,
    maxWidth:'100%',
    maxHeight: '100%',
    resizeMode: 'contain',
    alignContent: 'center',
    justifyContent: 'center',
    overflow:'hidden'
  },
});